import React, { Component } from "react";
import { InnerHeader, InnerItem } from "./Inners";
import "./Slide.scss";
import { apiURL } from "../../Services/baseURL";
import { handleSelected } from "../../Services/Storage";

export default class Slide extends Component {
    constructor(props) {
        super();
        this.ini8 = this.ini8.bind(this);
        this.renderItems = this.renderItems.bind(this);
        this.selectOption = this.selectOption.bind(this);
        this.ClickNavBar = this.ClickNavBar.bind(this);
        this.state = {
            items: [],
            hideArrow: false,
            Selected: -1,
            _Selects: {},
            render: ""
        }
    }
    componentDidMount() {
        this.ini8(this.props);
        window.addEventListener(`_resetSelected_${this.props.index}`, (event) => {
            this.setState({
                Selected: -1,
                render: ""
            }, () => {
                this.setState({
                    render: this.renderItems()
                })
            });
        });
    }
    ini8(props) {
        this.setState({
            items: props.items
        }, () => {
            this.setState({
                render: this.renderItems()
            })
        });
        window.addEventListener(`_scrollDown_${this.props.index}`, (event) => {
            window.setTimeout(() => {
                this.setState({
                    hideArrow: true
                })
            }, 3000);
        });
    }
    renderItems() {
        /**
         * ! REMOVE BEFORE FINAL BUILD THOSE LINES
         */
        // this.state.items.map((item, index) => {
        //     fetch(`${apiURL}InsertDB`, {
        //         method: 'POST',
        //         headers: {
        //             'Content-Type': 'application/json'
        //         },
        //         body: JSON.stringify({
        //             Name: item.Name,
        //             Category: this.props.index,
        //             CategoryName: item.Category,
        //             OptID: index,
        //             Votes: 0
        //         })
        //     }).then(data => data.json());
        // });
        return this.state.items.map((item, index) =>
            <InnerItem key={index} index={index}
                {...item}
                isActive={this.state.Selected == index}
                onClick={this.props.selectOption}
                selectOption={this.selectOption}
            />
        )
    }
    selectOption(index) {
        this.setState({
            Selected: index,
            render: ""
        }, () => {
            this.setState({
                _Selects: handleSelected.get("selected") != null ? JSON.parse(handleSelected.get("selected")) : {},
                render: this.renderItems()
            })
            window.setTimeout(() => {
                this.ClickNavBar(this.props.index + 1);
            }, 700);
        })
    }
    ClickNavBar(nextIndex) {
        if (Object.keys(this.state._Selects).length > 0) {
            for (let i = 0; i < this.props.CategoryLength; i++) {
                if(this.state._Selects[i] != null) continue;
                this.props.setNavBar(i);
                return;
            }
        }
        this.props.setNavBar(nextIndex);
    }
    render() {
        return (
            <div className="slider-item">
                <InnerHeader name={this.props.CategoryName} />
                <div className="arrowdown" style={{ display: this.state.hideArrow ? "none" : "" }}>
                    <div className="arrow"></div>
                </div>
                <div className="item-container">
                    {this.state.render}
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Components/Common/Slide/Slide.jsx